import * as React from 'react'
import { useFormikContext } from 'formik'

import { LeadFields } from './FieldSections/LeadFields'
import { PendingLeadFields } from './FieldSections/PendingLeadFields'
import { OpportunityFields } from './FieldSections/OpportunityFields'

import { ImportUtilityModel } from '../typings'
import { ImportEntityType } from '../../typings'

export function ImportUtilityContent() {
  const {
    values: { entityType },
  } = useFormikContext<ImportUtilityModel>()

  switch (entityType) {
    case ImportEntityType.DraftLead:
      return <PendingLeadFields />
    case ImportEntityType.Lead:
      return <LeadFields />
    case ImportEntityType.Opportunity:
      return <OpportunityFields />
    default:
      return null
  }
}
